// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GCeK","colBig":"styles_colBig__Iju3N","colSmall":"styles_colSmall__1OkIh"};